export enum Language {
  ENGLISH = "en",
  CHINESE = "zh-cn",
  JAPANESE = "ja",
}

export const LANGUAGE_CONFIG = Object.freeze({
  COUNTRY_QUERY_PARAM: "cy",
  LANGUAGE_QUERY_PARAM: "lang",
  COOKIE_NAME: "MDC.USER.LANGUAGE",
});

export interface LanguageData {
  menuLanguagePreferenceText: string;
  legacyCountry: string;
}

export const LANGUAGE_MAPPING: Record<Language, LanguageData> = Object.freeze({
  [Language.ENGLISH]: {
    legacyCountry: "global",
    menuLanguagePreferenceText: "English",
  },
  [Language.CHINESE]: {
    legacyCountry: "chn",
    menuLanguagePreferenceText: "Chinese",
  },
  [Language.JAPANESE]: {
    legacyCountry: "jpn",
    menuLanguagePreferenceText: "Japanese",
  },
});
